import React from 'react';
import { Meteor } from 'meteor/meteor';
import { createRoot } from 'react-dom/client';
import Buffer from 'buffer';
import { App } from '/imports/ui/App';
import '/imports/blobPolyfill';
import '/imports/android';
import '/imports/ios';

Meteor.startup(() => {
  if (!window.Buffer) window.Buffer = Buffer.Buffer;
  const container = document.getElementById('react-target');
  const root = container && createRoot(container);
  root && root.render(<App />);
});
